export default __webpack_public_path__ + "static/media/regulatory--do-not-stop-on-tracks--g1.f252110f.png";